import React, { useContext } from 'react'
import { VersionCardStyles } from './Style'
import { AutoComplete, Chip } from 'components/Form'
import { VersionsContext } from './VersionsContext'
import { Words } from 'pages'

const VersionCard = (props) => {
    const { version, setVersion, assessmentVersion, versions } = props

    return (
        <VersionCardStyles>
            <div className='version-header'>
                {!versions?.data ||
                    <div className='select-version'>
                        <AutoComplete
                            getOptionLabel={(opt) => ` גרסה ${opt.version} , נבדק ע"י ${opt.marking_words_update_by}`}
                            options={versions.data || []}
                            labelKey="version"
                            placeholder="בחר גרסה"
                            input={{
                                value: version,
                                onChange: setVersion
                            }}
                        />
                    </div>}
                <div className='version'>
                    {version?.version &&
                        <Chip color="dark">
                            {`גרסה ${version?.version}`}
                        </Chip>
                    }
                </div>
            </div>
            <div className='version-card'>
                <Words
                    hideHeader
                    wordsPerLine={2}
                    headerActions={[]}
                    type={assessmentVersion.data?.assessment_def_visible_type}
                    name={assessmentVersion.data?.assessment_def_name}
                    words={assessmentVersion.data?.words || []}
                    settings={{
                        viewResults: true
                    }}
                />
            </div>
        </VersionCardStyles>
    )
}

export default VersionCard
